import { splitFormartDate, _formatDate } from "../../../../../../libs/dateUtils";
import { IImmobilizedInventory } from "../models";

function verefyStateOfResponsabilityOfboolean(props) {
  const { statementOfResponsibility } = props;
  if (statementOfResponsibility == 1) return true;
  return false;
}

function verefyIfExistsValueAndIsNotBoolean(obj: any, i: string) {
  if (obj[i] && i !== "isDeleted" && i !== "statementOfResponsibility") return true;
  return false;
}

function verefyIsBoolean(i: string) {
  if (i === "isDeleted" || i === "statementOfResponsibility") return true;
  return false;
}

function objReceiveKeyAndValue(obj, key, value) {
  return (obj = { ...obj, [`${key}`]: value });
}

export function generateObject(obj, state) {
  let objGerated = {};
  let newObj: IImmobilizedInventory | any = {};
  let newObj2 = {};

  for (let i in obj) {
    const key = i;
    const value = obj[i];
    const data = objReceiveKeyAndValue(obj, key, value);
    objGerated = data;
    // objGerated = { ...objGerated, [`${key}`]: value };
  }

  for (let i in objGerated) {
    const key = i;
    const value = objGerated[i];
    if (verefyIfExistsValueAndIsNotBoolean(objGerated, i) && i !== "id") {
      const data = objReceiveKeyAndValue(newObj, key, value);
      newObj = data;
    }
    if (verefyIsBoolean(i) && i === "isDeleted") {
      const data = objReceiveKeyAndValue(newObj, key, state);
      newObj = data;
    }
    if (verefyIsBoolean(i)) {
      const data = objReceiveKeyAndValue(newObj, key, value);
      newObj = data;
    }
  }

  for (let i in newObj) {
    const key = [`${i}`];
    const value = objGerated[i];
    if (i === "userId" && newObj?.status === "Alocado") {
      const data = objReceiveKeyAndValue(newObj2, key, Number(obj[i]));
      newObj2 = data;
    }
    if (i !== "userId") {
      const data = objReceiveKeyAndValue(newObj2, key, value);
      newObj2 = data;
    }
    if(i === 'status' && newObj[i] !== "Em uso") {
      newObj2['responsible'] = ""
    }
  }

  return newObj2;
}

export function tratamentObject(obj) {
  let objNew: IImmobilizedInventory = obj;

  for (let i in objNew) {
    const key = [`${i}`];

    if (i === "invoice_number" || i === "asset_number") {
      const data = objReceiveKeyAndValue(objNew, key, String(obj[i]));
      objNew = data;
    }
    if (i === "userId") {
      const data = objReceiveKeyAndValue(objNew, key, Number(obj[i]));
      objNew = data;
    }
    if (i === "purchase_date") {
      const data = objReceiveKeyAndValue(objNew, key, inverseDate(obj[i]));
      objNew = data;
    }
    if (objNew?.status === "Vendido" || objNew?.status === "Doado" || objNew?.status === "Em manutenção") {
      const data = objReceiveKeyAndValue(objNew, "isDeleted", true);
      objNew = data;
    }
    if(i === 'status' && obj[i] !== "Em uso") {
      objNew['responsible'] = ""
    }
  }

  return objNew;
}

function inverseDate(obj) {
  const replaceDate = _formatDate(obj);
  const dateSplit = splitFormartDate(replaceDate);
  const dateInverse = `${dateSplit[2]}-${dateSplit[1]}-${dateSplit[0]}`;
  return dateInverse;
}
